import {Application} from "../application";

export class BaseMapper {
    constructor(
        protected application: Application
    ) {}
}
